import { render, staticRenderFns } from "./KYCDetailsForm.vue?vue&type=template&id=5490d472&scoped=true"
import script from "./KYCDetailsForm.vue?vue&type=script&lang=js"
export * from "./KYCDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./KYCDetailsForm.vue?vue&type=style&index=0&id=5490d472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490d472",
  null
  
)

export default component.exports